import React from 'react'
import styles from '../../../../css/RxartSecure/MessagesRS.module.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function MessagesRS ({ messParams, setMessParams, device }) {
  const { t } = useTranslation('dashboardDevice')

  const handleInputChange = (e) => {
    setMessParams({
      ...messParams,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className={styles.messagesContainer}>
      <div className={styles.inputContainer}>
        <label className={styles.labelInput}>{t('modalRxartSecure.label33')}</label>
        <textarea className={styles.textareaRS} name="messagesBlock" minLength={1} value={messParams.messagesBlock} onChange={(e) => handleInputChange(e)} disabled={device?.device?.license === 'No disponible'} placeholder={t('modalRxartSecure.label74')}/>
      </div>
      <div className={styles.inputContainer}>
        <label className={styles.labelInput}>{t('modalRxartSecure.label31')}</label>
        <textarea className={styles.textareaRS} name="messagesAdvertense" minLength={1} value={messParams.messagesAdvertense} onChange={(e) => handleInputChange(e)} disabled={device?.device?.license === 'No disponible'} placeholder={t('modalRxartSecure.label75')}/>
      </div>
    </div>
  )
}

MessagesRS.propTypes = {
  messParams: PropTypes.object,
  setMessParams: PropTypes.func,
  device: PropTypes.object
}
